/** A person's stage as a pill: watching now first, then how far they got in the room the row is about. */
import type { RegistrantSummary } from "../../../shared/types";
import { Pill, type PillTone } from "../../components/ui/Pill";

const TONE: Record<string, PillTone> = {
  signed: "good",
  watched: "good",
  clicked: "wine",
  attended: "brass",
  registered: "line",
  noshow: "warn",
};

/** Why two words: on a row about one room someone who never came "missed it"; across them all, a "No-show". */
export const stageLabel = (p: Pick<RegistrantSummary, "stage">, header = false) => (p.stage.cls === "noshow" && !header ? "Missed it" : p.stage.label);

export function StagePill({ p, header = false }: { p: Pick<RegistrantSummary, "stage" | "watching">; header?: boolean }) {
  if (p.watching) {
    return (
      <Pill tone="good" watching>
        Watching now
      </Pill>
    );
  }
  const label = stageLabel(p, header);
  return (
    <Pill tone={TONE[p.stage.cls] ?? "plain"} dot>
      {label}
    </Pill>
  );
}
